<template>
  <div class="nested-container">
    <div
      class="inner-container"
      :class="{ blur: !loaded }"
      :style="{ 'min-height': minHeight }">
      <slot></slot>
    </div>
    <div
      v-if="!loaded"
      class="spinner-wrapper"
    >
      <v-progress-circular :color="$vuetify.theme.primary" indeterminate v-if="loading"/>
      <div v-if="noData" class="content-container">
        <v-icon color="yellow" large>warning</v-icon>
        <br>
        <span class="subheading yellow--text">{{ noDataMessage }}</span>
      </div>
      <div v-if="error" class="content-container">
        <v-icon color="red" large>error</v-icon>
        <br>
        <span class="subheading red--text">{{ errorMessage }}</span>
        <br>
        <v-btn
          color="error"
          @click="reload"
        >
          <v-icon>refresh</v-icon>
          Reload
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
const ERR_MSG = 'Failed to load data';
const NO_DATA_MSG = 'No data';
const STATUS_ALLOWED = ['loading', 'loaded', 'noData', 'error'];

export default {
  props: {
    minHeight: {
      type: String,
      default: '50px',
    },
    status: {
      type: String,
      required: true,
      validator(status) {
        return STATUS_ALLOWED.includes(status);
      },
    },
    noDataMessage: {
      type: String,
      default: NO_DATA_MSG,
    },
    errorMessage: {
      type: String,
      default: ERR_MSG,
    },
  },
  computed: {
    loading() {
      return this.status === 'loading';
    },
    loaded() {
      return this.status === 'loaded';
    },
    noData() {
      return this.status === 'noData';
    },
    error() {
      return this.status === 'error';
    },
  },
  methods: {
    reload() {
      this.$emit('reload');
    },
  },
};
</script>

<style scoped>
  .nested-container {
    position: relative;
  }
  .spinner-wrapper {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  .inner-container {
    position: relative;
  }
  .blur {
    pointer-events: none;
    user-select: none;
    overflow: hidden;
    opacity: .7;
    filter: blur(.5px);
  }
  .content-container {
    text-align: center;
  }
</style>
